import { ErrorHandler, Inject, Injectable } from '@angular/core';
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot, Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';

import { AirportService } from '../../airport/airport.service';
import { Airport } from '../../airport/models/airport.model';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
import { EditToggleService } from '../../shared/services/edit-toggle.service';


@Injectable()
export class AirportResolver implements Resolve<Airport> {
  constructor(
    @Inject(DOCUMENT) private document: any,
    private _router: Router,
    private _airportService: AirportService,
    private _errorHandler: ErrorHandler,
    private _businessManagerService: BusinessManagerService,
    private _toggleService: EditToggleService
  ) { }

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Airport> {
    try {
      const id = route.paramMap.get('id');
      let airport = await this._airportService.getAirport(id);
      const isFlightDeckAdmin = await this._businessManagerService.isFlightDeckAdmin();
      const isAirportManager = await this._businessManagerService.userManagesAirport(airport.airportId);
      this._toggleService.setState(false);
      let isBusinessOwner = false;
      if (airport && !isFlightDeckAdmin) {
        for (const business of airport.businesses) {
          if (await this._businessManagerService.userOwnsBusiness(+business.id)) {
            isBusinessOwner = true;
          }
        }
      }
      if (isFlightDeckAdmin || isAirportManager || isBusinessOwner) {
        airport = await this._airportService.getAirport(id, true);
      }
      if (airport) {
        return airport;
      }
      // this.document.location.href = environment.notFoundUrl;
      this._router.navigate(['/404']);
      return null;
    } catch (e) {
      this._errorHandler.handleError(e);
      this._router.navigate(['/500']);
    }
  }
}
